"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadPackageEvents = exports.validateShipment = exports.loadShipment = exports.validateEstimateBody = exports.loadQuoteRequests = exports.loadHostedSessions = void 0;
var AUTH_KEY = 'ARTA_APIKey';
var logError = function (_a) {
    var status = _a.status, errors = _a.errors;
    console.log(errors);
    var keys = Object.keys(errors);
    if (status === 403) {
        console.error('Invalid API Key');
    }
    else if (status === 401) {
        console.error('Private API Key');
    }
    else if (status === 422) {
        keys.map(function (key) {
            console.error("".concat(key, " ").concat(errors[key]));
        });
    }
    else if (status === 400) {
        keys.map(function (key) {
            console.error("".concat(key, " ").concat(errors[key]));
        });
    }
    else {
        console.error('Unkonwn error', status, errors);
    }
};
var artaRequest = function (path_1, config_1, body_1, headers_1) {
    var args_1 = [];
    for (var _i = 4; _i < arguments.length; _i++) {
        args_1[_i - 4] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([path_1, config_1, body_1, headers_1], args_1, true), void 0, function (path, config, body, headers, method) {
        var schema, res, resBody, err;
        if (method === void 0) { method = 'POST'; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    schema = config.httpSchema ? config.httpSchema : 'https';
                    return [4 /*yield*/, fetch("".concat(schema, "://").concat(config.host).concat(path), {
                            method: method,
                            body: body,
                            headers: __assign(__assign({}, headers), { Authorization: "".concat(AUTH_KEY, " ").concat(config.apiKey), 'Content-Type': 'application/json' }),
                        })];
                case 1:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 2:
                    resBody = _a.sent();
                    if (!res.ok) {
                        err = Object.assign({}, {
                            errors: resBody['errors'],
                            status: res.status,
                            statusText: res.statusText,
                        });
                        logError(err);
                        return [2 /*return*/, { err: err }];
                    }
                    return [2 /*return*/, resBody];
            }
        });
    });
};
var loadHostedSessions = function (config, estimateBody) { return __awaiter(void 0, void 0, void 0, function () {
    var path, body, res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                path = '/estimate/hosted_sessions';
                body = JSON.stringify({ hosted_session: estimateBody });
                return [4 /*yield*/, artaRequest(path, config, body)];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res];
        }
    });
}); };
exports.loadHostedSessions = loadHostedSessions;
var loadQuoteRequests = function (config, hostedSession, estimateBody) { return __awaiter(void 0, void 0, void 0, function () {
    var path, body, headers, res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                path = '/estimate/requests';
                body = JSON.stringify({ request: estimateBody });
                headers = {
                    'hosted-session-id': hostedSession.id,
                    'hosted-session-private-token': hostedSession.private_token,
                };
                return [4 /*yield*/, artaRequest(path, config, body, headers)];
            case 1:
                res = _a.sent();
                res.quotes && res.quotes.forEach(function (q) { return (q.total = parseFloat(q.total)); });
                return [2 /*return*/, res];
        }
    });
}); };
exports.loadQuoteRequests = loadQuoteRequests;
var validateEstimateBody = function (config, estimateBody) { return __awaiter(void 0, void 0, void 0, function () {
    var path, body, res;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                path = '/estimate/validate';
                body = JSON.stringify({ estimate: estimateBody });
                return [4 /*yield*/, artaRequest(path, config, body)];
            case 1:
                res = _b.sent();
                return [2 /*return*/, (_a = res.err) === null || _a === void 0 ? void 0 : _a.errors];
        }
    });
}); };
exports.validateEstimateBody = validateEstimateBody;
var loadShipment = function (config, shipmentId) { return __awaiter(void 0, void 0, void 0, function () {
    var path, res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                path = "/embedded_tracking/shipments/".concat(shipmentId);
                return [4 /*yield*/, artaRequest(path, config, undefined, undefined, 'GET')];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res];
        }
    });
}); };
exports.loadShipment = loadShipment;
var validateShipment = function (config, shipmentId) { return __awaiter(void 0, void 0, void 0, function () {
    var path, res;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                path = "/embedded_tracking/shipments/".concat(shipmentId, "/validate");
                return [4 /*yield*/, artaRequest(path, config, undefined, undefined, 'GET')];
            case 1:
                res = _b.sent();
                return [2 /*return*/, (_a = res.err) === null || _a === void 0 ? void 0 : _a.errors];
        }
    });
}); };
exports.validateShipment = validateShipment;
var loadPackageEvents = function (config, shipmentId, packageId) { return __awaiter(void 0, void 0, void 0, function () {
    var path, res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                path = "/embedded_tracking/package_events/".concat(shipmentId, "/").concat(packageId);
                return [4 /*yield*/, artaRequest(path, config, undefined, undefined, 'GET')];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res];
        }
    });
}); };
exports.loadPackageEvents = loadPackageEvents;
